var _circle, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownloadIconSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  stroke: "#ffffff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 22L22.9282 15.25H9.0718L16 22Z",
  fill: "#ffffff"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 10,
  width: 4,
  height: 6,
  fill: "#ffffff"
})));
export { SvgDownloadIconSvg as ReactComponent };
export default __webpack_public_path__ + "72fc0d4ac9931cd51030da14c3970b56.svg";